import './index.css'
import { Fragment } from 'react'
import GlobalStyle from './styles'
import Routes from './routes'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import moment from 'moment-timezone'
import store from './store'
import Theme from './styles/themeProvider'
import { CustomProvider } from 'rsuite'
import 'rsuite/dist/rsuite.min.css'

moment.tz.setDefault('America/Fortaleza')

function App() {
    return (
        <Provider store={store}>
            <CustomProvider theme="light">
                <Theme>
                    <BrowserRouter>
                        <Fragment>
                            <GlobalStyle />
                            <Routes />
                        </Fragment>
                    </BrowserRouter>
                </Theme>
            </CustomProvider>
        </Provider>
    )
}

export default App

//
